import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { Box, Button, IconButton, Popover, MenuItem } from "@mui/material";
import { HttpService } from "../../service/HttpService";
import { useAuth } from "../../context/AuthProvider";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";
import dayjs from "dayjs";
import { Decryption } from "../../Mixin/EncryptDecryptId";
import { Encryption } from "../../Mixin/EncryptDecryptId";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TbFilterEdit } from "react-icons/tb";
import "./SopsListAdd/Sops.scss";
import Excel from "../../assets/img/excel.png";
import Word from "../../assets/img/word.png";
import Pdf from "../../assets/img/pdf.png";
import { BsArrowLeft } from "react-icons/bs";
import DeleteModal from "../../components/Model/DeleteModal";
import Checkbox from "@mui/material/Checkbox";
import { GoTrash } from "react-icons/go";
import { getFileName } from "../../utils/common";

const radioOptions = [
  { value: "today", label: "Today" },
  { value: "week", label: "This Week" },
  { value: "month", label: "This Month" },
  { value: "specific", label: "Specific Date Range" },
];

const SopFileHistory = () => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [sopDetails, setSopDetails] = useState([]);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [label, setLabel] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { id } = params || {};
  const decryptedId = id && Decryption(id);
  const historyDateFilter = localStorage.getItem("sopFileHistoryDateFilter");
  const dateFilterData = historyDateFilter
    ? JSON.parse(historyDateFilter)
    : null;
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );
  const [selectedId, setSelectedId] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();

  const handleRadioChange = () => {
    const setlabel =
      radioOptions.find((option) => option.value === selectedRadio)?.label ||
      "";
    setLabel(setlabel);
  };

  const fetchSopFileHistory = async () => {
    setLoading(true);
    try {
      // Adjust the endpoint as needed for file history
      const response = await httpService.get(
        `sops/getById/${decryptedId}?start_date=${startDate}&end_date=${endDate}`
      );
      setHistory(
        response?.data?.sop_file_history?.map((item, idx) => ({
          id: item.id,
          emp_name: item.emp_name,
          history_filename: item.history_filename,
          viewed_at: item.viewed_at,
        })) || []
      );
      setSopDetails(response?.data?.sopdetails);
    } catch (error) {
      setHistory([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleRadioChange();
    fetchSopFileHistory();
    // eslint-disable-next-line
  }, []);

  const handleOpenDateModal = () => setOpenDateModal(true);
  const handleCloseDateModal = () => setOpenDateModal(false);
  const handleFetchWithFilter = () => {
    fetchSopFileHistory();
    const dateFilter = {
      startDate: startDate,
      endDate: endDate,
      selectedRadio: selectedRadio,
    };
    localStorage.setItem(
      "sopFileHistoryDateFilter",
      JSON.stringify(dateFilter)
    );
    handleRadioChange();
    setOpenDateModal(false);
  };

  // Checkbox logic
  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = history.map((row) => row.id);
      setSelectedId(allIds);
    } else {
      setSelectedId([]);
    }
    setIsAllSelected(isChecked);
  };
  const isIdSelected = (id) => selectedId.includes(id);
  const toggleId = (id) => {
    setSelectedId((prev) => {
      if (prev.includes(id)) {
        const updated = prev.filter((item) => item !== id);
        setIsAllSelected(false);
        return updated;
      } else {
        const updated = [...prev, id];
        if (updated.length === history.length) setIsAllSelected(true);
        return updated;
      }
    });
  };

  // Delete logic
  const handleDelete = (id) => {
    setDeleteRowId(id);
    setBulkDelete(false);
    setOpenDeleteModal(true);
  };
  const handleBulkDelete = () => {
    setBulkDelete(true);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteRowId(null);
    setBulkDelete(false);
  };
  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      if (bulkDelete) {
        await httpService.post("sops/delete_all_sopFileHistory", {
          ids: selectedId,
        });
        setSelectedId([]);
        setIsAllSelected(false);
        fetchSopFileHistory();
      } else if (deleteRowId) {
        await httpService.delete(`sops/sopFileHistoryDelete/${deleteRowId}`);
        setSelectedId([]);
        fetchSopFileHistory();
      }
    } catch (e) {
      // handle error if needed
    }
    setLoading(false);
    handleCloseDeleteModal();
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setDataId(id);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setDataId(null);
  };

  const columns = [
    // {
    //   field: "select_All",
    //   headerName: "",
    //   minWidth: 50,
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <Checkbox
    //       checked={isAllSelected ? true : isIdSelected(params.row.id)}
    //       onChange={() => toggleId(params.row.id)}
    //     />
    //   ),
    //   renderHeader: () => (
    //     <Checkbox
    //       checked={isAllSelected}
    //       onChange={handleHeaderCheckboxChange}
    //     />
    //   ),
    // },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   minWidth: 100,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //     <>
    //       <div className="action_icon-weap">
    //         <IconButton onClick={(e) => handleMenuClick(e, params.row.id)}>
    //           <GridMoreVertIcon />
    //         </IconButton>
    //       </div>
    //       {anchorEl && dataId === params.row.id && (
    //         <Popover
    //           className="popup-menu"
    //           key={dataId}
    //           open={Boolean(anchorEl)}
    //           anchorEl={anchorEl}
    //           onClose={handleCloseMenu}
    //           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    //           transformOrigin={{ vertical: "top", horizontal: "right" }}
    //         >
    //           <MenuItem
    //             onClick={() => {
    //               handleDelete(params.row.id);
    //               handleCloseMenu();
    //             }}
    //             className="menu-list-items"
    //           >
    //             <div className="menu-list-items-text">Delete</div>
    //             <GoTrash style={{ cursor: "pointer" }} />
    //           </MenuItem>
    //         </Popover>
    //       )}
    //     </>
    //   ),
    // },
    {
      field: "history_filename",
      headerName: "File Name",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <span style={{ fontWeight: 500 }}>
          {params.row.history_filename || "--"}
        </span>
      ),
    },
    {
      field: "emp_name",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <span>{params.row.emp_name || "--"}</span>,
    },
    {
      field: "viewed_at",
      headerName: "Viewed At",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD-MM-YYYY hh:mm A") : "--",
    },
  ];

  return (
    <div className="sops">
      {loading && <FullScreenLoader />}
      <div className="page-title">
        <div className="title-wrap">
          <h1>
            <span className="back">
              <BsArrowLeft
                onClick={() => {
                  if (location.state?.from) {
                    const urlEncodedId = Encryption(location.state?.from);
                    navigate(`/sops/history/${urlEncodedId}`);
                  }
                }}
              />
            </span>
            File History Of SOP -{" "}
            {sopDetails?.name ? `(${sopDetails?.name})` : ""}
          </h1>
        </div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleOpenDateModal}
            className="filters-btn"
          >
            <TbFilterEdit /> Filter
          </Button>
        </div>
      </div>
      {/* Bulk Delete Button */}
      {/* <div style={{ margin: "16px 0" }}>
        <Button
          variant="contained"
          color="error"
          disabled={selectedId.length === 0}
          onClick={handleBulkDelete}
          startIcon={<GoTrash />}
          style={{ textTransform: "none", fontWeight: 600 }}
        >
          Delete
        </Button>
      </div> */}
      <Box mt={3}>
        <DataGrid
          rows={history}
          columns={columns}
          autoHeight
          pageSizeOptions={[10, 25, 50]}
          disableRowSelectionOnClick
          sx={{
            background: "#fff",
            borderRadius: 2,
            [`& .MuiDataGrid-cell`]: { py: 1 },
          }}
          hideFooter
        />
      </Box>
      <DateTimeModal
        handleDateTimeModal={handleCloseDateModal}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        open={openDateModal}
        fetchSchedule={handleFetchWithFilter}
        selectedRadio={selectedRadio}
        setSelectedRadio={setSelectedRadio}
        startDate={startDate}
        endDate={endDate}
      />
      {/* Delete Modal */}
      <DeleteModal
        open={openDeleteModal}
        HandleClose={handleCloseDeleteModal}
        HandleDelete={handleConfirmDelete}
      />
    </div>
  );
};

export default SopFileHistory;
